import Typography from "@material-ui/core/Typography";
import React from "react";
import { TitleFC } from "./types";

const Title: TitleFC = ({ title }) => (
  <Typography variant={"subtitle2"} sx={{ fontWeight: 700 }}>
    {title}
  </Typography>
);

export default Title;
